import common from "./common";
import weld from "./weld";
import features from "./features";
import panels from "./panels";

export default {
	common,
	weld,
	features,
	panels,
};
